<template>
  <Suspense>
    <template #default>
      <ShoptetPluginSettings />
    </template>
    <template #fallback> Loading... </template>
  </Suspense>
</template>

<script setup lang="ts">
import ShoptetPluginSettings from './ShoptetPluginSettings.vue';
</script>
